import { useState } from "react";
import moment from "moment";

export default function useDateRange() {
  const [dataRange, setDataRange] = useState({
    fromValue: moment().subtract(1, "months").toDate(),
    toValue: null,
  });

  const onDateRangeChange = (dates) => {
    const [start, end] = dates;
    setDataRange({ fromValue: start, toValue: end });
  };

  return { dataRange, onDateRangeChange };
}
